/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentArtifactsControllerFindAllByDocumentQueryResponse, DocumentArtifactsControllerFindAllByDocumentPathParams, DocumentArtifactsControllerFindAllByDocumentQueryParams, DocumentArtifactsControllerFindAllByDocument404 } from "../../models/documentArtifactsController/DocumentArtifactsControllerFindAllByDocument";

function getDocumentArtifactsControllerFindAllByDocumentUrl(documentId: DocumentArtifactsControllerFindAllByDocumentPathParams["documentId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/artifacts` as const }  
  return res
}

/**
 * @description Returns all artifacts for a document, organized by their parent renditions. Provides a document-centric view of all artifacts.
 * @summary List all artifacts for a document grouped by rendition
 * {@link /api/v1/documents/:documentId/artifacts}
 */
export async function documentArtifactsControllerFindAllByDocument(documentId: DocumentArtifactsControllerFindAllByDocumentPathParams["documentId"], params: DocumentArtifactsControllerFindAllByDocumentQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentArtifactsControllerFindAllByDocumentQueryResponse, ResponseErrorConfig<DocumentArtifactsControllerFindAllByDocument404>, unknown>({ method : "GET", url : getDocumentArtifactsControllerFindAllByDocumentUrl(documentId).url.toString(), params, ... requestConfig })  
  return res.data
}